// extracted by mini-css-extract-plugin
module.exports = {"container":"svg_container__c0Ogn","gradient":"svg_gradient__q91L2"};